import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { setFetchRule } from '../../../../../../../actions/common';
import { OPERATORS_REQUIRE_VALUE } from '../../../../../../../constants';
import FormRuleTableBase, { RuleTableContext } from '../FormRuleTableBase';
import { RuleContext } from './CreateFormCrawlRule';
import TableHeaderRow from './lookup/TableHeaderRow';
import TableBodyRows from './lookup/TableBodyRows';
import ImportExportTable from './lookup/ImportExportTable';

// Re-export as FormCrawlTableContext so sub-components can import from this file unchanged
export const FormCrawlTableContext = RuleTableContext;

const FormCrawlRuleTable = ({ initialStepsData, actionType }) => {
     const { rule, setRule } = useContext(RuleContext);
     const selectedListenerRule = useSelector((state) => state.subscriber.selectedListenerRule);

     const validateFn = (tableRow) => {
          const errorColumn = { type: '', key: '' };
          [...tableRow].some((row) => {
               const flag = row.conditions.some((col) => {
                    const { type, value, key, operator } = col.g0;
                    if (key !== 'Page Location') return false;
                    if (value.trim() === '' && OPERATORS_REQUIRE_VALUE.includes(operator)) {
                         Object.assign(errorColumn, { type, key });
                         return true;
                    }
                    return false;
               });
               return flag;
          });
          return errorColumn;
     };

     const onRevertSuccess = (d, setStepsData) => {
          d(setFetchRule());
          setStepsData(null);
     };

     return (
          <FormRuleTableBase
               variant='crawl-block'
               stepsData={rule}
               setStepsData={setRule}
               initialStepsData={initialStepsData}
               isCreateMode={actionType === 'create'}
               rulesStateKey='formCrawlRules'
               selectedListenerRule={selectedListenerRule}
               validateFn={validateFn}
               onRevertSuccess={onRevertSuccess}
               TableHeaderRow={TableHeaderRow}
               TableBodyRows={TableBodyRows}
               ImportExportTable={ImportExportTable}
               scrollThreshold={300}
          />
     );
};

FormCrawlRuleTable.propTypes = {
     initialStepsData: PropTypes.object,
     actionType: PropTypes.string,
};

export default FormCrawlRuleTable;
